import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../basket/types';
import {
  RestoreConfig,
  ServiceRestoreStateGenerator,
  serviceRestoreStateGeneratorProcessor,
} from './types';

/**
 * BaseServiceRestoreStateGenerator реализует сервис восстановления стейтов услуг
 */
export class BaseServiceRestoreStateGenerator implements ServiceRestoreStateGenerator {
  protected processors: serviceRestoreStateGeneratorProcessor[];

  /**
   * Конструктор сервиса
   * @param processors
   */
  constructor(processors: serviceRestoreStateGeneratorProcessor[]) {
    this.processors = processors;
  }

  /**
   * Restore выполняет восстановление стейта для шаблонов на
   * основе переданных полей и услуг.
   * @param services
   * @param globalFields
   * @param globalFieldValues
   * @param variantFields
   * @param variantFieldValues
   * @param existStore
   */
  async Restore(
    setUpServiceData: SetUpServiceData,
    services: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder,
    restoreConfig: RestoreConfig
  ) {
    let resultAdditionalServiceState: AdditionServicesState = {
      ...additionalServiceState,
      IsRestoringState: false,
    };
    let resultOptionsState: AdditionServicesOptionsState = { ...optionsState };
    let resultServiceCacheState: AServiceCache = { ...serviceCacheState };
    let resultServicePropertyCacheState: AServicePropertyCache = { ...servicePropertyCacheState };
    let resultServicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder = {
      ...servicePropertyFilterAndOrderState,
    };

    for (const processor of this.processors) {
      const {
        isValid,
        additionalServiceState,
        optionsState,
        serviceCacheState,
        servicePropertyCacheState,
        servicePropertyFilterAndOrderState,
      } = await processor.restore(
        setUpServiceData,
        services,
        resultAdditionalServiceState,
        resultOptionsState,
        resultServiceCacheState,
        resultServicePropertyCacheState,
        resultServicePropertyFilterAndOrderState,
        restoreConfig
      );

      resultAdditionalServiceState = additionalServiceState;
      resultOptionsState = optionsState;
      resultServiceCacheState = serviceCacheState;
      resultServicePropertyCacheState = servicePropertyCacheState;
      resultServicePropertyFilterAndOrderState = servicePropertyFilterAndOrderState;

      if (!isValid) {
        break;
      }
    }

    return {
      additionalServiceState: resultAdditionalServiceState,
      optionsState: resultOptionsState,
      serviceCacheState: resultServiceCacheState,
      servicePropertyCacheState: resultServicePropertyCacheState,
      servicePropertyFilterAndOrderState: resultServicePropertyFilterAndOrderState,
    };
  }
}
